import React from 'react';
import { Button } from '@mui/material';
import Link from 'next/link';
import { Rutas } from '@/constants/rutas';
import { usePrismaContext } from '../../context/PrismaContext';
import CustomImageComponent from '@/components/shared/custom/custom-image';
import { getCountryImage } from '@/helpers/images-helper';

const LanguageSwitcher = ({ sx = {} }) => {
    const { isEnglishVersion } = usePrismaContext();

    const defaultStyles = {
        color: 'white',
        bgcolor: 'transparent',
        '&:hover': { bgcolor: 'rgba(255,255,255,0.1)' },
        minWidth: '40px',
        width: '40px',
        height: '40px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: 0,
    };

    return (
        <Link href={isEnglishVersion ? Rutas.PRISMA : Rutas.PRISMA_EN}>
            <Button variant="text" sx={{ ...defaultStyles, ...sx }}>
                <CustomImageComponent
                    src={isEnglishVersion ? getCountryImage('es') : getCountryImage('us')}
                    alt={isEnglishVersion ? 'Español' : 'English'}
                    title={isEnglishVersion ? 'Cambiar a Español' : 'Switch to English'}
                    width={24}
                    height={24}
                />
            </Button>
        </Link>
    );
};

export default LanguageSwitcher;
